/**
 * Home hero with the Webflow page-load reveal (IX2 a-15 / a-52).
 *
 * The image starts full-width and shrinks to its resting 40% (desktop) while
 * the four headline lines flip up in sequence (rotateX) and the navbar fades
 * in. Mobile slides the image up instead of shrinking it.
 */
import type { FC } from 'react'

import { useEffect } from 'react'

import { gsap } from '@/lib/gsap'

export const Hero: FC = () => {
    useEffect(() => {
        const lines = [
            '.hero-text-holder._01',
            '.hero-text-holder._02',
            '.hero-text-holder._03',
            '.hero-text-holder._04',
            '.hero-link-holder._05'
        ]

        const ctx = gsap.context(() => {
            const isDesktop = window.matchMedia('(min-width: 768px)').matches

            gsap.set('.hero-image-container', { width: '100%' })
            if (isDesktop) {
                gsap.set('.hero-image', { width: '100%', xPercent: 8 })
            } else {
                gsap.set('.hero-image', { width: '100%', height: '100%', yPercent: 100 })
            }
            gsap.set(lines, { opacity: 0, y: 20, rotationX: -89 })
            gsap.set('.fixed-navbar', { opacity: 0 })

            const tl = gsap.timeline({ defaults: { ease: 'power1.inOut' } })

            tl.to('.hero-image-container', { width: isDesktop ? '40%' : '100%', duration: 0.8 }, 0)

            if (isDesktop) {
                tl.to('.hero-image', { xPercent: 0, width: '40%', duration: 0.8 }, 0)
            } else {
                tl.to('.hero-image', { yPercent: 0, duration: 0.8 }, 0)
            }

            lines.forEach((line, index) => {
                tl.to(line, { opacity: 1, y: 0, rotationX: 0, duration: 0.8 }, 0.5 + index * 0.1)
            })

            tl.to('.fixed-navbar', { opacity: 1, duration: 0.7 }, 1)
        })

        return () => ctx.revert()
    }, [])

    return (
        <div className='section hero-section'>
            <div className='container hero-container'>
                <div className='hero-text-container'>
                    <div className='perspective'>
                        <div className='hero-text-holder _01'>
                            <h1 className='hero-text'>GET</h1>
                        </div>
                    </div>
                    <div className='perspective'>
                        <div className='hero-text-holder _02'>
                            <h1 className='hero-text'>YOURSELF</h1>
                        </div>
                    </div>
                    <div className='perspective'>
                        <div className='hero-text-holder _03'>
                            <h1 className='hero-text white'>INTO THE</h1>
                        </div>
                    </div>
                    <div className='perspective'>
                        <div className='hero-text-holder _04'>
                            <h1 className='hero-text white'>RIGHT GEAR</h1>
                        </div>
                    </div>
                    <div className='perspective'>
                        <div className='hero-link-holder _05'>
                            <a href='#Season' className='button with-arrow w-button'>VIEW SUMMER COLLECTIONS</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className='hero-image-container'>
                <div className='hero-image-holder'>
                    <img src='/images/Hero-Image-Landsacpe.jpg' loading='lazy' alt='' className='hero-image' />
                </div>
                <div className='hero-image-decord' />
            </div>
        </div>
    )
}
